import React from "react";
import {Col, Row} from "antd";
import {MyBreadcrumb} from "../../components";


export const Report = () => {
  return (
    <>
      <MyBreadcrumb title="Отчеты"/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>

            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}